import React, { useState } from 'react';
import { TextField, Typography, Box, Button } from '@mui/material';
import ModalForms from '../../Shared/Modals';

const DeclineHoldModal = ({ declineHoldModal, setDeclineHoldModal }) => {
    const [reason, setReason] = useState('');

    const handleSubmit = () => {
        setDeclineHoldModal({ show: false, type: '' });
        setReason('');
    };

    const modalBody = (
        <>
            <Typography variant="body2" sx={{ mb: 2 }}>
                {declineHoldModal.type === 'Decline'
                    ? "Please enter the reason below why this proposal can't be converted to a campaign."
                    : 'Please enter the reason below why this proposal is on hold.'}
            </Typography>

            <TextField
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                placeholder="Enter your reason here..."
                sx={{ mb: 2 }}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
            />
        </>
    );

    const modalFooter = (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
            >
                Notify
            </Button>
        </Box>
    );

    return (
        <ModalForms
            show={declineHoldModal.show}
            handleClose={() => setDeclineHoldModal({ show: false, type: '' })}
            modalHeader="Specify Reason"
            modalBody={modalBody}
            modalFooter={modalFooter}
            modalId="decline-hold-reason"
            size="sm"
        />
    );
};

export default DeclineHoldModal;
